import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useChannelsStore = defineStore('channelsStore', {
  state () {
    const blocks = ref([])
    const prevBlocks = ref(null)
    const tab = ref('')

    const originTimestamps = ref({})
    const movableBlock = ref(null)
    const movableBlockStartPos = ref(null)
    const movableBlockCurrentPos = ref(null)

    const setMovingBlock = (data) => {
      if (!prevBlocks.value) {
        // делаю копию оригинального списка, что бы можно было вернуть исходное состояние
        prevBlocks.value = blocks.value.map(i => ({ id: i.id, timestamp: i.timestamp }))
      }

      blocks.value.forEach(i => {
        if (i.status === 'wait' || i.status === 'start') return

        originTimestamps.value[i.id] = {
          start: i.timestamp,
          end: i.timestamp + i.duration
        }
      })
    }

    const moveBlock = (block, timestamp) => {
      const currentBlock = blocks.value.find(i => i.id === movableBlock.value.id)
      if (!currentBlock) return

      const distance = movableBlockStartPos.value - timestamp

      movableBlockStartPos.value = timestamp
      movableBlockCurrentPos.value = currentBlock.timestamp

      distance < 0
        ? moveBlockToRight()
        : moveBlockToLeft()
    }

    const moveBlockToRight = () => {
      const blocksList = blocks.value.sort((a, b) => a.timestamp - b.timestamp)

      for (let i = 0; i < blocksList.length; i++) {
        const block = blocksList[i]
        const stop = block.timestamp + block.duration

        // Проверка на пересечение со следующими блоками
        for (let j = i + 1; j < blocksList.length; j++) {
          const nextBlock = blocksList[j]

          if (nextBlock.timestamp < stop) {
            /**
             * Округляем до целых секунд и добавляем одну секунду, что бы блоки не пересекались
             * Перемещение начала следующего блока
             */
            nextBlock.timestamp = Math.floor(stop + 1)

            if (blockDragMode.value === 'float') {
              const freePos = checkFreeOriginPosToRight(nextBlock.id)

              if (freePos) {
                nextBlock.timestamp = freePos
              }
            }
          }
        }
      }
    }

    const checkFreeOriginPosToRight = (blockId) => {
      if (blockId === movableBlock.value.id) return false

      const block = originTimestamps.value[blockId]
      if (!block) return false

      return block.end < movableBlockCurrentPos.value ? block.start : false
    }

    const moveBlockToLeft = () => {
      const blocksList = blocks.value.sort((a, b) => a.timestamp - b.timestamp)

      for (let i = blocksList.length - 1; i >= 0; i--) {
        const block = blocksList[i]

        for (let j = i - 1; j >= 0; j--) {
          const nextBlock = blocksList[j]
          const stop = nextBlock.timestamp + nextBlock.duration

          if (stop > block.timestamp) {
            /**
             * Округляем до целых секунд и вычитаем одну секунду, что бы блоки не пересекались
             * Перемещение начала следующего блока
             */
            nextBlock.timestamp = Math.floor(block.timestamp - nextBlock.duration - 1)

            if (blockDragMode.value === 'float') {
              const freePos = checkFreeOriginPosToLeft(nextBlock.id)

              if (freePos) {
                nextBlock.timestamp = freePos
              }
            }
          }
        }
      }
    }

    const checkFreeOriginPosToLeft = (blockId) => {
      if (blockId === movableBlock.value.id) return false

      const block = originTimestamps.value[blockId]
      if (!block) return false

      const start = block.start

      return start > movableBlockCurrentPos.value + movableBlock.value.duration ? start : false
    }

    const clearMovableBlock = () => {
      movableBlock.value = null
      movableBlockStartPos.value = null
      movableBlockCurrentPos.value = null
      originTimestamps.value = {}
    }

    const blockDragMode = ref('single') // single || package || float

    const timelineScale = ref(2)

    const now = ref(new Date())

    setInterval(() => {
      now.value = new Date()
    })

    const isLoading = ref(false)

    return {
      now,
      channels: [],
      channel: undefined,
      blocks,
      prevBlocks,
      movableBlock,
      block: undefined,
      originTimestamps,
      selectedDate: new Date(),
      timelineScale,
      blockDragMode,
      tab,
      isLoading,
      setMovingBlock,
      moveBlock,
      clearMovableBlock
    }
  }
})
